import {Navigate} from 'react-router-dom'
import {CrudProvider} from '../../../../services/loggedin/CrudContext'
import {ListComponent} from '../../../parts/crud/List'
import {useState} from 'react'
import {format, set} from 'date-fns'
import {ActionType, ColumnType, DefaultMenuActions} from '../../../parts/crud/Types'

export const LicencesList = () => {
  const [redirect, setRedirect] = useState('')
  let actions: ActionType[] = DefaultMenuActions
  let myacttion: ActionType[] = [
    {
      title: 'Visualizza licenze',
      type: 'link',
      action: 'show_licences',
      icon: 'fa-solid fa-magnifying-glass',
    },
  ]
  actions = [...myacttion, ...actions]
  const columns: Array<ColumnType> = [
    {title: 'Pacchetto', key: 'name', type: 'text', orderable: true},
    {
      title: 'Tenant',
      key: 'group_name',
      type: 'custom',
      orderable: true,
      render: (item: any) => {
        let check = <i className='fa-solid fs-2 fa-times text-danger'></i>
        if (item.enabled === 1) {
          check = <i className='fa-solid fs-2 fa-check text-success'></i>
        }
        return (
          <>
            {item['group_name']} {check}
          </>
        )
      },
    },
    {title: 'Creata Il', key: 'created', type: 'datetime', orderable: true},
    {title: 'Modificata Il', key: 'updated', type: 'datetime', orderable: true},
    {
      title: 'Valida fino al',
      key: 'expiration',
      type: 'custom',
      orderable: true,
      render: (item: any) => {
        let alert = <></>

        //se data scadenza è minore di oggi meno 10 giorni allora alert
        if (
          new Date(item['expiration']) < new Date(new Date().setDate(new Date().getDate() + 10))
        ) {
          alert = (
            <>
              <i className='fa-solid fa-triangle-exclamation text-danger fs-2'></i>{' '}
            </>
          )
        }
        return (
          <>
            {alert}
            {format(new Date(item['expiration']), 'dd/MM/yyyy')}
          </>
        )
      },
    },
    {
      title: 'Licenze',
      key: 'bound_tokens',
      type: 'custom',
      orderable: true,
      render: (data: any) => {
        return <>{data.bound_tokens + ' / ' + data.tokens}</>
      },
    },
  ]
  return (
    <>
      {redirect !== '' ? <Navigate to={redirect}></Navigate> : <></>}
      <CrudProvider api='licences'>
        <ListComponent
          menuClicked={(action, data) => {
            if (action === 'show_licences') {
              setRedirect('/licences/view/' + data.id)
              return false
            }
            return true
          }}
          actions={actions}
          defOrder='updated'
          defOrderDir='desc'
          columns={columns}
          title_delete='Eliminazione pacchetto'
          text_eliminare="Sei sicuro di voler eliminare questo pacchetto?L'operazione non è reversibile"
          text_eliminato='Pacchetto eliminato con successo'
          text_nuovo='Nuovo pacchetto'
        ></ListComponent>
      </CrudProvider>
    </>
  )
}
